import { environment } from 'environments/environment';
import { Mutation, Query } from '../api-hooks/types';
import { User } from '@models/user';

const baseUrl = environment.apiUrl + 'api/';

export const apiLogin = (
  username: string,
  password: string
): Mutation<{ access: string; refresh: string }> => ({
  url: `${baseUrl}token/`,
  method: 'POST',
  data: { username, password },
});

export const apiLogout = (): Mutation<void> => ({
  url: `${baseUrl}logout/`,
  method: 'POST',
});

export const getCurrentUser = (): Query<User> => ({
  url: `${environment.apiUrl}users/current/`,
});
